// AppLocationPermissionModal.tsx
import React from "react";
import { useLocationAccess } from "../../contexts/LocationContext";
import { APP_NAME } from "../../constants/constants";
import inPopup from "../../utils/hoc/inPopup";
import { getPlatform } from "../../utils/platformUtil";
const STEPS: Record<string, string[]> = {
    'android': [
        "Go to App Settings",
        "Select Permissions",
        "Select Location Permission",
        `Allow location permission to ${APP_NAME}`
    ],
    "ios": [
        "Go to Settings",
        "Select Location",
        `Grant location permission to ${APP_NAME}`
    ]
}

const AppLocationPermission: React.FC<{isActive: boolean; onClose: () => void; onSettings: () => void}> = ({ onClose, onSettings }) => {
    const platform = getPlatform();
    return (
        <div className="p-3">
             <div className="modal-header border-0">
                        <h4 className="modal-title fw-bold">Grant Location Permission</h4>
                        <button type="button" className="btn-close rounded-circle bg-light" onClick={onClose}></button>
                    </div>

                    <div className="modal-body py-3 pb-0">
                        {
                            (STEPS[platform] ?? []).map((step, i) => (<div key={i} className="d-flex align-items-center mb-2">
                            <div className="rounded-circle bg-light d-flex justify-content-center align-items-center"
                                style={{ width: 32, height: 32 }}>
                                <span className="fw-bold">{i+1}</span>
                            </div>
                            <span className="ms-2 fs-7">{step}</span>
                        </div>))
                        }
                    </div>
                    <div className="divider my-3"></div>
                 <div className="border-0 d-flex justify-content-between gap-2">
                     <button className="btn btn-sm w-50 btn-secondary rounded-sm" onClick={onClose}>Cancel</button>
                        <button className="btn btn-sm w-50 theme-btn-primary rounded-sm" onClick={onSettings}>Settings</button>
                 </div>
        </div>
    )
}

const AppLocationPermissionPopup = inPopup(AppLocationPermission);

const AppLocationPermissionModal: React.FC = () => {
    const {showPermissionPopup: show, openSettings, hidePermissionPopup} = useLocationAccess();
    return (
        <AppLocationPermissionPopup isActive={show} onClose={hidePermissionPopup} onSettings={openSettings} />
    );
};

export default AppLocationPermissionModal;
